function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgColorPv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccccff"
    },
    id: "OPT-color_x5F_24_1_",
    d: "M11.5,20c-0.2,0-0.3,0-0.5,0c-4.4-0.1-9-2.5-9-7c0-5.5,3.7-9,9.5-9C17.7,4,22,8,22,11.5 c0,3.5-2.6,3.5-3.5,3.5c-0.5,0-0.9,0-1.2,0.1c-0.2,0.1-0.3,0.2-0.3,0.4c0,2-0.5,2.8-1.2,3.4C14.6,19.9,13.2,20,11.5,20z M11.5,5 C5.3,5,3,9.2,3,13c0,3.8,4.1,6,8,6c1.6,0,3.1,0,4.2-0.9c0.4-0.3,0.8-0.6,0.8-2.6c0-0.7,0.3-1.1,1-1.3c0.5-0.2,1-0.2,1.5-0.2 c1.2,0,2.5-0.2,2.5-2.5C21,8.5,17.1,5,11.5,5z M6,12.5c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5 C7.5,13.2,6.9,12.5,6,12.5z M8,8.5c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5C9.5,9.2,8.9,8.5,8,8.5z  M13,7.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S13.9,7.5,13,7.5z M17,9.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5 c0.8,0,1.5-0.7,1.5-1.5S17.9,9.5,17,9.5z M12,17.6c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.2,17.6,12,17.6z M12,14.6 c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1s1-0.4,1-1C13,15,12.6,14.6,12,14.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgColorPv);
export default __webpack_public_path__ + "static/media/img_ColorPv.40fdbe2bfd3e8f9585cd8b97d0406e44.svg";
export { ForwardRef as ReactComponent };